package com.example.mystybag.permissionsUtils.expected

import androidx.compose.runtime.Composable
import com.example.mystybag.core.expected.Activity

actual object PermissionHelper {
    actual fun hasPermission(permission: Permission): Boolean = true
    actual suspend fun requestPermission(permission: Permission, activity: Activity): Boolean = true
    @Composable
    actual fun PermissionView() {}
}
